import React from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { 
  FaUserTie, 
  FaUsers, 
  FaCode, 
  FaMobile, 
  FaBullhorn, 
  FaChartLine,
  FaCogs,
  FaShieldAlt,
  FaLightbulb,
  FaHandshake,
  FaArrowLeft,
  FaEnvelope,
  FaLinkedin,
  FaGithub,
  FaAward,
  FaGraduationCap,
  FaBriefcase,
  FaStar,
  FaPhone
} from "react-icons/fa";
import "../assets/styles/TeamDetails.css";

const TeamDetails = () => {
  const navigate = useNavigate();
  const { roleId } = useParams();

  const handleBackToTeam = () => {
    navigate('/roles');
  };

  const teamMembers = {
    1: {
      id: 1,
      name: "Sarah Johnson",
      title: "Chief Executive Officer (CEO)",
      icon: <FaUserTie size={64} />,
      category: "Leadership",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=400&h=400&fit=crop&crop=face",
      description: "Strategic leader with over 15 years of experience in the technology industry, driving innovation and growth across all business areas.",
      responsibilities: [
        "Strategic planning and business development",
        "Team leadership and company culture",
        "Financial oversight and investor relations",
        "Market expansion and partnerships",
        "Technology roadmap and innovation strategy",
        "Stakeholder management and board relations"
      ],
      experience: [
        "15+ years of executive experience in tech industry",
        "Former CTO at TechCorp (2018-2022)",
        "VP of Engineering at InnovateTech (2015-2018)",
        "Senior Director at GlobalSoft (2012-2015)"
      ],
      skills: [
        "Strategic Leadership",
        "Business Development",
        "Team Management",
        "Financial Planning",
        "Technology Strategy",
        "Investor Relations"
      ],
      education: [
        "MBA - Harvard Business School (2012)",
        "BS Computer Science - MIT (2010)",
        "Certified Scrum Master (CSM)"
      ],
      achievements: [
        "Led company to 300% revenue growth in 3 years",
        "Successfully raised $50M Series B funding",
        "Named 'Tech Leader of the Year' 2023",
        "Expanded operations to 5 new countries"
      ],
      contact: {
        email: "sarah.johnson@asyncvibe.com",
        linkedin: "linkedin.com/in/sarahjohnson",
        phone: "+1 (555) 123-4567"
      }
    },
    2: {
      id: 2,
      name: "Michael Chen",
      title: "Project Manager",
      icon: <FaUsers size={64} />,
      category: "Management",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face",
      description: "Experienced project manager with a proven track record of delivering complex software projects on time and within budget.",
      responsibilities: [
        "Project planning and resource allocation",
        "Team coordination and stakeholder management",
        "Risk assessment and mitigation",
        "Quality assurance and delivery",
        "Agile methodology implementation",
        "Client communication and relationship management"
      ],
      experience: [
        "8+ years of project management experience",
        "Senior PM at TechFlow (2020-2023)",
        "Project Lead at DevCorp (2018-2020)",
        "Scrum Master at AgileTech (2016-2018)"
      ],
      skills: [
        "Project Management",
        "Agile/Scrum",
        "Risk Management",
        "Team Leadership",
        "Stakeholder Management",
        "JIRA & Confluence"
      ],
      education: [
        "PMP Certification (2021)",
        "Certified Scrum Master (CSM) - 2019",
        "BS Business Administration - Stanford (2016)"
      ],
      achievements: [
        "Delivered 25+ successful projects worth $10M+",
        "Reduced project delivery time by 30%",
        "Led team of 15 developers across 3 continents",
        "Achieved 98% client satisfaction rate"
      ],
      contact: {
        email: "michael.chen@asyncvibe.com",
        linkedin: "linkedin.com/in/michaelchen",
        phone: "+1 (555) 234-5678"
      }
    },
    3: {
      id: 3,
      name: "Emily Rodriguez",
      title: "Human Resources Manager",
      icon: <FaHandshake size={64} />,
      category: "HR",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face",
      description: "Dedicated HR professional passionate about creating inclusive workplaces and developing talent to drive organizational success.",
      responsibilities: [
        "Recruitment and talent acquisition",
        "Employee relations and performance management",
        "Training and development programs",
        "HR policies and compliance",
        "Diversity and inclusion initiatives",
        "Employee engagement and retention"
      ],
      experience: [
        "5+ years of HR experience",
        "HR Manager at GrowthTech (2021-2023)",
        "HR Specialist at PeopleFirst (2019-2021)",
        "HR Coordinator at TalentCorp (2018-2019)"
      ],
      skills: [
        "Talent Acquisition",
        "Employee Relations",
        "Performance Management",
        "HR Compliance",
        "Training & Development",
        "HRIS Systems"
      ],
      education: [
        "Master's in Human Resources - Cornell (2018)",
        "BS Psychology - UCLA (2016)",
        "SHRM-CP Certification (2020)"
      ],
      achievements: [
        "Reduced employee turnover by 25%",
        "Implemented successful remote work policies",
        "Launched company-wide diversity training program",
        "Improved employee satisfaction score to 4.8/5"
      ],
      contact: {
        email: "emily.rodriguez@asyncvibe.com",
        linkedin: "linkedin.com/in/emilyrodriguez",
        phone: "+1 (555) 345-6789"
      }
    },
    4: {
      id: 4,
      name: "David Kim",
      title: "Full Stack Developer",
      icon: <FaCode size={64} />,
      category: "Development",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face",
      description: "Passionate full-stack developer with expertise in modern web technologies and a love for creating elegant, scalable solutions.",
      responsibilities: [
        "Frontend and backend development",
        "Database design and API development",
        "Code review and technical documentation",
        "Performance optimization and testing",
        "Mentoring junior developers",
        "Technology stack evaluation"
      ],
      experience: [
        "3+ years of full stack development",
        "Senior Developer at WebFlow (2022-2023)",
        "Full Stack Developer at CodeCraft (2020-2022)",
        "Frontend Developer at UIBuild (2019-2020)"
      ],
      skills: [
        "React.js & Node.js",
        "TypeScript & JavaScript",
        "MongoDB & PostgreSQL",
        "AWS & Docker",
        "GraphQL & REST APIs",
        "Testing & CI/CD"
      ],
      education: [
        "BS Computer Science - UC Berkeley (2019)",
        "Full Stack Web Development Bootcamp",
        "AWS Certified Developer Associate"
      ],
      achievements: [
        "Built 15+ production applications",
        "Improved application performance by 40%",
        "Mentored 5 junior developers",
        "Contributed to 3 open-source projects"
      ],
      contact: {
        email: "david.kim@asyncvibe.com",
        linkedin: "linkedin.com/in/davidkim",
        github: "github.com/davidkimdev",
        phone: "+1 (555) 456-7890"
      }
    },
    5: {
      id: 5,
      name: "Alex Thompson",
      title: "Mobile App Developer",
      icon: <FaMobile size={64} />,
      category: "Development",
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face",
      description: "Innovative mobile developer specializing in cross-platform solutions and creating engaging user experiences across iOS and Android.",
      responsibilities: [
        "iOS and Android app development",
        "UI/UX implementation and testing",
        "App store optimization and deployment",
        "Performance monitoring and updates",
        "Cross-platform development",
        "Mobile security implementation"
      ],
      experience: [
        "3+ years of mobile development",
        "Mobile Developer at AppStudio (2022-2023)",
        "iOS Developer at MobileCorp (2020-2022)",
        "Junior Developer at AppCraft (2019-2020)"
      ],
      skills: [
        "Flutter & React Native",
        "Swift & Kotlin",
        "iOS & Android SDKs",
        "Firebase & AWS",
        "UI/UX Design",
        "App Store Optimization"
      ],
      education: [
        "BS Software Engineering - Georgia Tech (2019)",
        "Mobile App Development Certification",
        "Apple Developer Program Member"
      ],
      achievements: [
        "Published 8 apps on App Store & Play Store",
        "Achieved 4.8+ star ratings across all apps",
        "Reduced app crash rate by 60%",
        "Implemented successful monetization strategies"
      ],
      contact: {
        email: "alex.thompson@asyncvibe.com",
        linkedin: "linkedin.com/in/alexthompson",
        github: "github.com/alexthompson",
        phone: "+1 (555) 567-8901"
      }
    }
  };

  const teamMember = teamMembers[roleId];

  if (!teamMember) {
    return (
      <div className="team-details-page">
        <Container>
          <div className="text-center py-5">
            <h2>Team Member Not Found</h2>
            <Button onClick={handleBackToTeam} variant="primary">
              Back to Team
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="team-details-page">
      {/* Back Button */}
      <div className="back-button-section">
        <Container>
          <Button 
            variant="link" 
            className="back-button"
            onClick={handleBackToTeam}
          >
            <FaArrowLeft /> Back to Team
          </Button>
        </Container>
      </div>

      {/* Hero Section */}
      <section className="team-hero">
        <Container>
          <Row className="align-items-center">
            <Col lg={4} className="text-center mb-4 mb-lg-0">
              <div className="team-member-image">
                <img 
                  src={teamMember.image} 
                  alt={teamMember.name}
                  className="member-photo"
                />
                <div className="member-icon-overlay">
                  {teamMember.icon}
                </div>
              </div>
            </Col>
            <Col lg={8}>
              <div className="team-member-info">
                <Badge bg="primary" className="member-category mb-3">
                  {teamMember.category}
                </Badge>
                <h1 className="member-name">{teamMember.name}</h1>
                <h2 className="member-title">{teamMember.title}</h2>
                <p className="member-description">{teamMember.description}</p>
                
                {/* Contact Information */}
                <div className="member-contact">
                  <div className="contact-item">
                    <FaEnvelope />
                    <span>{teamMember.contact.email}</span>
                  </div>
                  <div className="contact-item">
                    <FaLinkedin />
                    <span>{teamMember.contact.linkedin}</span>
                  </div>
                  {teamMember.contact.github && (
                    <div className="contact-item">
                      <FaGithub />
                      <span>{teamMember.contact.github}</span>
                    </div>
                  )}
                  <div className="contact-item">
                    <FaPhone />
                    <span>{teamMember.contact.phone}</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Detailed Information */}
      <section className="team-details-content">
        <Container>
          <Row className="g-4">
            {/* Responsibilities */}
            <Col lg={6}>
              <Card className="detail-card">
                <Card.Header className="detail-card-header">
                  <FaBriefcase className="detail-icon" />
                  <h3>Key Responsibilities</h3>
                </Card.Header>
                <Card.Body>
                  <ul className="detail-list">
                    {teamMember.responsibilities.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            {/* Experience */}
            <Col lg={6}>
              <Card className="detail-card">
                <Card.Header className="detail-card-header">
                  <FaStar className="detail-icon" />
                  <h3>Professional Experience</h3>
                </Card.Header>
                <Card.Body>
                  <ul className="detail-list">
                    {teamMember.experience.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            {/* Skills */}
            <Col lg={6}>
              <Card className="detail-card">
                <Card.Header className="detail-card-header">
                  <FaCode className="detail-icon" />
                  <h3>Technical Skills</h3>
                </Card.Header>
                <Card.Body>
                  <div className="skills-container">
                    {teamMember.skills.map((skill, index) => (
                      <Badge key={index} bg="secondary" className="skill-badge">
                        {skill}
                      </Badge>
                    ))}
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Education */}
            <Col lg={6}>
              <Card className="detail-card">
                <Card.Header className="detail-card-header">
                  <FaGraduationCap className="detail-icon" />
                  <h3>Education & Certifications</h3>
                </Card.Header>
                <Card.Body>
                  <ul className="detail-list">
                    {teamMember.education.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </Card.Body>
              </Card>
            </Col>

            {/* Achievements */}
            <Col lg={12}>
              <Card className="detail-card">
                <Card.Header className="detail-card-header">
                  <FaAward className="detail-icon" />
                  <h3>Key Achievements</h3>
                </Card.Header>
                <Card.Body>
                  <Row>
                    {teamMember.achievements.map((achievement, index) => (
                      <Col key={index} md={6} className="mb-3">
                        <div className="achievement-item">
                          <FaStar className="achievement-icon" />
                          <span>{achievement}</span>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default TeamDetails;

